"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var hours_list_1 = require("../../../common/constants/hours_list");
var minutes_list_1 = require("../../../common/constants/minutes_list");
var dcDriveSessionTypesController = /** @class */ (function () {
    function dcDriveSessionTypesController(UserService, DriveSessionTypesModel, ReportcardsTypesModel, FlashService) {
        this.UserService = UserService;
        this.DriveSessionTypesModel = DriveSessionTypesModel;
        this.ReportcardsTypesModel = ReportcardsTypesModel;
        this.FlashService = FlashService;
        this.currentUser = UserService.getCurrentUser();
        this.initialTab = 0;
        this.getSessionTypes();
        this.getReportCardTypes();
        this.displayHelp = this.displayHelp.bind(this);
        this.hoursList = hours_list_1.hours_list;
        this.minutesList = minutes_list_1.minutes_list;
        this.ageRuleOptions = [
            { n: "All ages", v: "all" },
            { n: ">= (at least)", v: "minimum" },
            { n: "<= (at most)", v: "maximum" },
        ];
        this.newProduct = { age_rule: "all" };
    }
    dcDriveSessionTypesController.prototype.disable = function (sessiontype) {
        var _this = this;
        var data = Object.assign({}, sessiontype);
        data.status = "Disabled";
        this.DriveSessionTypesModel.update(data)
            .then(function (response) {
            _this.sessionTypes = response.sessionTypes;
        })
            .catch(function (response) {
            _this.updating = false;
        });
    };
    dcDriveSessionTypesController.prototype.displayHelp = function (subject) {
        var helpText = "";
        switch (subject) {
            case "allow_custom_pickup_locations":
                helpText =
                    'This will allow a student to be picked up at an address of their choosing. Set this to "No" if you would only like students to be picked up at the school for this session type.';
                break;
            case "allow_custom_dropoff_locations":
                helpText =
                    'This will allow a student to be dropped off at an address of their choosing. Set this to "No" if you would only like students to be dropped off at the school for this session type.';
                break;
            case "send_instructor_change_notification":
                helpText =
                    'If the instructor on this session is changed, a notification email will be sent to the student on the session and their guardian if this setting is set to "Yes"';
                break;
            case "send_last_minute_availability_alert":
                helpText =
                    "If a student cancels a session within the window specified in the Cancellations screen, a notification (either a text message, an email, or both) will be sent to " +
                        'every student and their guardian who are in the same zone as the cancelled session if this setting is set to "Yes".';
                break;
            case "disable_notifications_after_completion_of_curriculum":
                helpText =
                    'When a student completes all of the hours they have purchased for this session type they will no longer receive text message or email alerts of ANY newly available sessions if this setting is set to "Yes". If they wish to continue receiving notifications they (or an admin) will have to update the setting in their profile.';
                break;
            case "auto_verify_on_purchase":
                helpText =
                    'In DriveScout, verification means adding the hours for a session type a student has purchased to their account. When this setting is set to "Yes" when a student or their guardian purchases a product with this session type in it, their hours will automatically be updated to reflect their purchase.';
                break;
            case "allow_observations":
                helpText =
                    "This will allow this session type to be booked as an Observation, which allows more than one student to be on one drive session at a time.";
                break;
            case "age_rule":
                helpText =
                    'Restrict this session type to students of a certain age. Choose ">= (at least)" or "<= (at most)" and enter an age. ' +
                        "Students whose age does not match cannot book, be booked into, or purchase this session type. " +
                        'The comparison includes the age itself, so ">= 18" allows students who are exactly 18. Ages are calculated from the student\'s date of birth.';
                break;
            default:
                helpText = "";
                break;
        }
        return helpText;
    };
    dcDriveSessionTypesController.prototype.getSessionTypes = function () {
        var _this = this;
        this.DriveSessionTypesModel.get().then(function (response) {
            _this.sessionTypes = response.sessionTypes;
            _this.tabs = _this.sessionTypes.map(function (sessionType) {
                return __assign(__assign({}, sessionType), { title: sessionType.name });
            });
        });
    };
    dcDriveSessionTypesController.prototype.getReportCardTypes = function () {
        var _this = this;
        this.ReportcardsTypesModel.get().then(function (response) {
            _this.reportCardTypes = response.data;
        });
    };
    dcDriveSessionTypesController.prototype.addProduct = function () {
        var _this = this;
        var productData = Object.assign({}, this.newProduct);
        this.DriveSessionTypesModel.insert(productData).then(function (response) {
            _this.sessionTypes = _this.sessionTypes.concat(response.sessionType);
            _this.newProduct = { age_rule: "all" };
        });
    };
    dcDriveSessionTypesController.prototype.updatePayRatio = function (sessionType) {
        var _this = this;
        this.updating = true;
        this.DriveSessionTypesModel.update(sessionType)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.updating = false;
        })
            .catch(function (response) {
            _this.updating = false;
        });
    };
    return dcDriveSessionTypesController;
}());
dcDriveSessionTypesController.$inject = [
    "UserService",
    "DriveSessionTypesModel",
    "ReportcardsTypesModel",
    "FlashService",
];
exports.default = dcDriveSessionTypesController;
